'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var button = require('./button-c50f4784.js');
var kebabCase = require('./kebabCase-b150ced7.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: ", ";\n  margin: 0 0.25em;\n  -webkit-tap-highlight-color: transparent;\n  position: relative;\n"], ["\n  width: ", ";\n  margin: 0 0.25em;\n  -webkit-tap-highlight-color: transparent;\n  position: relative;\n"])), function (_a) {
    var width = _a.width;
    return width + "px";
});
var WheelPickerViewport = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  height: ", ";\n  position: relative;\n  overflow: hidden;\n"], ["\n  width: 100%;\n  height: ", ";\n  position: relative;\n  overflow: hidden;\n"])), function (_a) {
    var height = _a.height;
    return height + "px";
});
var WheelPickerWrapper = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  height: ", ";\n  top: 50%;\n  margin-top: -20px;\n  width: 100%;\n"], ["\n  position: absolute;\n  height: ", ";\n  top: 50%;\n  margin-top: -20px;\n  width: 100%;\n"])), function (_a) {
    var height = _a.height;
    return height + "px";
});
var WheelPickerScroll = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  list-style-type: none;\n  padding: 0;\n  user-select: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  ", "\n  ", "\n"], ["\n  list-style-type: none;\n  padding: 0;\n  user-select: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  ", "\n  ",
    "\n"])), function (_a) {
    var isAnimating = _a.isAnimating;
    return isAnimating && 'transition: transform 0.2s linear;';
}, function (_a) {
    var translateY = _a.translateY;
    return "\n    transform: translateY(" + translateY + "px);\n  ";
});
var WheelPickerItem = styled__default.li(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  height: ", ";\n  padding: 8px 16px;\n  box-sizing: border-box;\n  width: 100%;\n  color: ", ";\n  font: 400 20px/24px ", ";\n  font-size: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: ", ";\n  pointer-events: ", ";\n  ", "\n  ", "\n  ", "\n  "], ["\n  height: ", ";\n  padding: 8px 16px;\n  box-sizing: border-box;\n  width: 100%;\n  color: ", ";\n  font: 400 20px/24px ", ";\n  font-size: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: ", ";\n  pointer-events: ", ";\n  ",
    "\n  ",
    "\n  ",
    "\n  "])), function (_a) {
    var height = _a.height;
    return height + "px";
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var isClickDisabled = _a.isClickDisabled;
    return (!isClickDisabled ? 'none' : 'transform 0.1s linear, opacity 0.1s linear');
}, function (_a) {
    var isClickDisabled = _a.isClickDisabled;
    return (isClickDisabled ? 'none' : 'auto');
}, function (_a) {
    var scale = _a.scale, opacity = _a.opacity;
    return "\n    transform: scale(" + scale + ");\n    opacity: " + opacity + ";\n  ";
}, function (_a) {
    var selected = _a.selected, theme = _a.theme;
    return selected
        && "\n      color: " + theme.colors.greys.adminBlack + ";\n      background: " + theme.colors.greys.adminGreyMedium + ";\n      border-radius: 5px;\n      height: auto;\n      padding: 8px 16px;\n    ";
}, function (_a) {
    var selected = _a.selected;
    return !selected
        && "\n      overflow: hidden;\n      white-space: nowrap;\n    ";
});
var ButtonStyled = styled__default(button.Button)(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: 16px;\n  padding: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: 16px;\n  padding: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

var SCALE_RATE = 0.1;
var OPACITY_RATE = 0.2;
var MAX_ITEM_OFFSET = 10;
var calculateItemValues = function (itemIndex, selectedItemIndex, rate) {
    var itemOffset = Math.abs(selectedItemIndex - itemIndex);
    return itemOffset < MAX_ITEM_OFFSET ? 1 - itemOffset * rate : 0;
};
var WheelPickerItemsList = function (_a) {
    var items = _a.items, itemHeight = _a.itemHeight, currentIndex = _a.currentIndex, isAnimating = _a.isAnimating, translateY = _a.translateY, onClick = _a.onClick, isScrolling = _a.isScrolling;
    var handleOnClick = React.useCallback(function (value) { return function () { return onClick === null || onClick === void 0 ? void 0 : onClick(value); }; }, [onClick]);
    return (React__default.createElement(WheelPickerScroll, { translateY: translateY, isAnimating: isAnimating }, items.map(function (_a, index) {
        var value = _a.value, label = _a.label;
        return (React__default.createElement(WheelPickerItem, { onClick: handleOnClick(value), key: value.toString(), height: itemHeight, isClickDisabled: isScrolling, selected: currentIndex === index, scale: calculateItemValues(index, currentIndex, SCALE_RATE), opacity: calculateItemValues(index, currentIndex, OPACITY_RATE), className: "wheel-picker-item", "data-testid": "wheel-picker-item", "data-cy": "wheel-picker-item-" + kebabCase.kebabCase_1(value.toString()) }, label));
    })));
};

exports.ButtonStyled = ButtonStyled;
exports.Container = Container;
exports.WheelPickerItemsList = WheelPickerItemsList;
exports.WheelPickerViewport = WheelPickerViewport;
exports.WheelPickerWrapper = WheelPickerWrapper;
